// Mobile Performance Monitoring Script
// Add to the bottom of theme.liquid for testing

(function() {
  'use strict';
  
  // Only run on mobile
  if (window.innerWidth > 749) return;
  
  // Performance metrics
  const perfData = {
    startTime: performance.now(),
    loadTime: 0,
    domContentLoaded: 0,
    firstContentfulPaint: 0,
    largestContentfulPaint: 0
  };
  
  // Track DOM Content Loaded
  document.addEventListener('DOMContentLoaded', function() {
    perfData.domContentLoaded = performance.now() - perfData.startTime;
    console.log('DOM Content Loaded:', Math.round(perfData.domContentLoaded), 'ms');
  });
  
  // Track full page load
  window.addEventListener('load', function() {
    perfData.loadTime = performance.now() - perfData.startTime;
    console.log('Page Load Complete:', Math.round(perfData.loadTime), 'ms');
    
    // Get Web Vitals
    if ('getEntriesByType' in performance) {
      // First Contentful Paint
      const fcp = performance.getEntriesByType('paint').find(entry => entry.name === 'first-contentful-paint');
      if (fcp) {
        perfData.firstContentfulPaint = fcp.startTime;
        console.log('First Contentful Paint:', Math.round(fcp.startTime), 'ms');
      }
    }
    
    // Track LCP via Performance Observer
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const lcp = entries[entries.length - 1];
          perfData.largestContentfulPaint = lcp.startTime;
          console.log('Largest Contentful Paint:', Math.round(lcp.startTime), 'ms');
        });
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
        
        // Disconnect after 5 seconds
        setTimeout(() => observer.disconnect(), 5000);
      } catch (e) {
        console.log('LCP monitoring not supported');
      }
    }
    
    // Report summary after 2 seconds
    setTimeout(function() {
      console.log('=== MOBILE PERFORMANCE SUMMARY ===');
      console.log('DOM Ready:', Math.round(perfData.domContentLoaded), 'ms');
      console.log('Page Load:', Math.round(perfData.loadTime), 'ms');
      console.log('FCP:', Math.round(perfData.firstContentfulPaint), 'ms');
      console.log('LCP:', Math.round(perfData.largestContentfulPaint), 'ms');
      
      // Simple performance rating
      if (perfData.loadTime < 2000) {
        console.log('🟢 Performance: EXCELLENT');
      } else if (perfData.loadTime < 4000) {
        console.log('🟡 Performance: GOOD');  
      } else if (perfData.loadTime < 6000) {
        console.log('🟠 Performance: NEEDS IMPROVEMENT');
      } else {
        console.log('🔴 Performance: POOR');
      }
    }, 2000);
  });
  
  // Track resource loading
  const resourceObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (entry.duration > 100) { // Only log slow resources
        console.log('Slow Resource:', entry.name.split('/').pop(), Math.round(entry.duration) + 'ms');
      }
    });
  });
  
  resourceObserver.observe({ entryTypes: ['resource'] });
  
})();